import React from "react";

const Footer = () => {
    return (
        <footer className="footer footer-center p-4 bg-black text-base-content">
            <div>
                <p className="text-white">Copyright © 2022 - All right reserved by Cloud Kitchen.</p>
            </div>
        </footer>
    );
}
export default Footer;